module.exports = __webpack_public_path__ + "img/1369817445.89cf1e16.jpg";